// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".line1[data-v-2b66aa9d] {\n  width: 200px;\n}\n.sku[data-v-2b66aa9d] {\n  font-weight: 400;\n}\n.al-c[data-v-2b66aa9d] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.merName[data-v-2b66aa9d] {\n  width: 100px;\n}\n.fenge[data-v-2b66aa9d] {\n  margin: 0 3px;\n}", ""]);
// Exports
module.exports = exports;
